import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="aboutus-wrapper">
      <div className="aboutus-content p-4 md:p-6 text-700 line-height-3">
        <h3 className="text-3xl font-bold text-900 mb-4">DevBrows – Built to Power Your Business</h3>
        <p className="mb-4">
          DevBrows isn’t just another digital agency. We're a team of friends-turned-founders who started with a simple question over dinner:
          <strong> "Why do businesses have to settle for average when it comes to their digital presence?"</strong>
        </p>

        <h4 className="text-2xl font-semibold text-900 mb-2">Our Story</h4>
        <p className="mb-3">
          It all started in a small apartment where roommates—passionate about design, code, and making a difference—kept hearing the same struggles from local businesses: “We don’t know how to build a website,” or “We tried, but it’s too expensive.”
        </p>
        <p className="mb-4">
          That’s when the lightbulb moment hit. We realized we could change that. With our combined skills in development, strategy, and user experience, we set out to create a service that gives every business the power of a custom-built website without the high costs, headaches, or compromises.
        </p>

        <h4 className="text-2xl font-semibold text-900 mb-2">Why We Exist</h4>
        <p className="mb-4">
          We built DevBrows to help small businesses thrive in the digital world—with websites and platforms that are beautiful, fast, and uniquely theirs. No cookie-cutter templates. No hidden costs. Just tailor-made solutions that reflect who you are and what your customers need.
        </p>

        <h4 className="text-2xl font-semibold text-900 mb-2">Our Promise</h4>
        <p className="mb-3">
          Your privacy and trust mean everything to us. That’s why we don’t use open-source templates or expose your business data. Every project is private, secured, and created from scratch for you and only you.
        </p>
        <p className="mb-4">
          From your first landing page to a full-fledged digital storefront, we’ll be there—turning your ideas into reality, and your brand into something unforgettable.
        </p>

        <h4 className="text-2xl font-semibold text-900 mb-2">Let’s Build Something Great</h4>
        <p className="mb-4">
          We’re not just building websites. We’re building growth, trust, and long-term partnerships. Let’s create something powerful, together.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
